import { render, staticRenderFns } from "./DynamicalDevOps.vue?vue&type=template&id=21995a26&scoped=true"
import script from "./DynamicalDevOps.vue?vue&type=script&lang=js"
export * from "./DynamicalDevOps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21995a26",
  null
  
)

export default component.exports